import { useQuery } from '@tanstack/react-query'
import { QUERY_KEYS } from '../../constants/queryKeys'
import { getOperationinstructionTablePMS } from '../../api/operation'
function useGetInstructionTableOperationPMS(id?: string) {
   return useQuery({
      queryKey: [QUERY_KEYS.GET_INSTRUCTION_TABLE_OPERATION_PMS, id],
      queryFn: () => getOperationinstructionTablePMS(id),
      enabled: !!id,
   })
}
export { useGetInstructionTableOperationPMS }
export default useGetInstructionTableOperationPMS
